import loadable from '@loadable/component';
import './TransitInput.css';

export default loadable(() => {
  return import('./TransitInput.jsx');
});
